export const state = {
  showSuccessModal: false,
}

export const mutations = {
  SET_SUCCESS_MODAL(state, show) {
    state.showSuccessModal = show
  },
}

export const actions = {
  openSuccessModal({ commit }) {
    commit('SET_SUCCESS_MODAL', true)
  },
  closeSuccessModal({ commit }) {
    commit('SET_SUCCESS_MODAL', false)
  },
}